/** Browser classification for checkout window sizing. Mobile and embedded
 * browsers use an ordinary tab so the opener/result protocol is retained.
 * Legacy strategy names remain internal for compatibility with consumers. */
export type PopupStrategy = 'desktop-window' | 'mobile-redirect' | 'native-bridge'

export function detectStrategy(): PopupStrategy {
  if (typeof window === 'undefined') return 'mobile-redirect'

  const ua = navigator.userAgent || ''
  const isMobile = /Android|iPhone|iPad|iPod|Mobile/i.test(ua)
  const isWebview = isInAppWebview(ua)

  if (isWebview) return 'native-bridge'
  if (isMobile) return 'mobile-redirect'
  return 'desktop-window'
}

function isInAppWebview(ua: string): boolean {
  // Heuristics — not exhaustive but covers the most common cases.
  if (/FBAN|FBAV/i.test(ua)) return true // Facebook in-app browser
  if (/Instagram/i.test(ua)) return true
  if (/Twitter|TwitterAndroid/i.test(ua)) return true
  if (/Line\//i.test(ua)) return true
  // iOS WKWebView: no "Safari" token. Android WebView: contains "wv".
  if (/iPhone|iPad|iPod/i.test(ua) && !/Safari/i.test(ua)) return true
  if (/Android/i.test(ua) && /; wv\)/i.test(ua)) return true
  return false
}
